import { getBooleanQueryValue, isValidBooleanQuery } from '@/utils/query-utils';

import { SearchParams } from '@domain/app';

export const useReorderQuery = () => {
    const url = window.location.href.replace('#', '/');
    const query = new URL(url).searchParams;
    const reorderQuery = query.get(SearchParams.REORDER);

    if (reorderQuery === null || !isValidBooleanQuery(reorderQuery)) {
        return false;
    }

    return getBooleanQueryValue(reorderQuery);
};
